import Vue from "vue";
//功能模块：服务案例
export default Vue.extend({
    name: "cases",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        caseList: function () {
            var temp = this.$t('products');
            var url = "../../../static/img/cases/";
            for (var _i = 0, _a = temp['p6']; _i < _a.length; _i++) {
                var item = _a[_i];
                item.img = url + item.img;
            }
            return temp['p6'];
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/cases.vue
// module id = null
// module chunks = 